"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _material = require("@mui/material");

var _styles = require("@mui/material/styles");

var _colors = require("../../colors");

var _excluded = ["value", "onChange", "tabIndex", "success", "error", "focused"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var StyledInput = (0, _styles.styled)(_material.TextField)(function () {
  return {
    width: '47.83px',
    borderRadius: '4px'
  };
});

var MFAInput = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
  var value = _ref.value,
      onChange = _ref.onChange,
      tabIndex = _ref.tabIndex,
      success = _ref.success,
      error = _ref.error,
      focused = _ref.focused,
      props = _objectWithoutProperties(_ref, _excluded);

  var getFontColor = function getFontColor() {
    if (success) {
      return _colors.GREEN_PRIMARY;
    }

    if (error) {
      return _colors.LIGHT_RED;
    }

    return 'inherit';
  };

  return /*#__PURE__*/_react.default.createElement(StyledInput, _extends({
    inputRef: function inputRef(innerRef) {
      return ref.current = innerRef;
    },
    focused: focused,
    tabIndex: tabIndex,
    value: value,
    onChange: onChange,
    inputProps: {
      sx: {
        fontSize: '18px',
        color: getFontColor(),
        fontWeight: 700,
        textAlign: 'center',
        borderRadius: '4px',
        border: "".concat(success || error ? '2px' : '1px', " solid ").concat(getFontColor()),
        '&:focus': {
          background: 'white',
          border: 'none'
        }
      }
    }
  }, props));
});

var _default = MFAInput;
exports.default = _default;